if (!customElements.get('wlsn-buybox-gallery')) {
  class WLSNBuyboxGallery extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        active: 'active',
        hidden: 'hidden',
        disabled: 'disabled',
        mainSlider: 'js-buybox-gallery-main-slider',
        thumbSlider: 'js-buybox-gallery-thumb-slider',
        mainSlide: 'js-buybox-gallery-main-slide',
        thumbSlide: 'js-buybox-gallery-thumb-slide',
        thumbContainer: 'js-buybox-gallery-thumb-container',
        mainNavButtonPrev: 'js-wlsn-slider-prev',
        mainNavButtonNext: 'js-wlsn-slider-next',
      };

      this.bindMethods = {};

      this.mainSwiper = null;
      this.thumbSwiper = null;
      this.minThumbsForSlider = 2;

      this.rem = parseFloat(getComputedStyle(document.documentElement).fontSize);
    }

    /**
     * Get DOM elements
     * @returns {object} - Object containing DOM element references
     */
    get elements() {
      return {
        mainSlider: this.querySelector(`.${this.classes.mainSlider}`),
        thumbSlider: this.querySelector(`.${this.classes.thumbSlider}`),
        mainSlides: this.querySelectorAll(`.${this.classes.mainSlide}`),
        thumbSlides: this.querySelectorAll(`.${this.classes.thumbSlide}`),
        thumbContainer: this.querySelector(`.${this.classes.thumbContainer}`),
        mainNavButtonPrev: this.querySelector(`.${this.classes.mainNavButtonPrev}`),
        mainNavButtonNext: this.querySelector(`.${this.classes.mainNavButtonNext}`),
      };
    }

    /**
     * Connected callback lifecycle method
     * @returns {void}
     */
    connectedCallback() {
      this.initThumbSlider();
      this.initMainSlider();
    }

    /**
     * Disconnected callback lifecycle method
     * @returns {void}
     */
    disconnectedCallback() {
      if (this.mainSwiper) {
        this.mainSwiper.destroy(true, true);
      }
      if (this.thumbSwiper) {
        this.thumbSwiper.destroy(true, true);
      }
    }

    /**
     * Initialize the thumbnail slider
     * @returns {void}
     */
    initThumbSlider() {
      const { thumbContainer, thumbSlider, thumbSlides } = this.elements;
      if (!thumbContainer || !thumbSlider) return;

      // Check if we have enough thumbnails to show slider
      if (thumbSlides.length < this.minThumbsForSlider) {
        this.hideThumbSlider();
        return;
      }

      const thumbConfig = {
        loop: false,
        spaceBetween: (7 / 10) * this.rem,
        slidesPerView: 6,
        watchSlidesProgress: true,
        clickable: true,
        centerInsufficientSlides: true,
        breakpoints: {
          1024: {
            slidesPerView: 5,
          },
          1320: {
            slidesPerView: 6,
          }
        },
      };

      this.thumbSwiper = new Swiper(thumbSlider, thumbConfig);

      // Check if we have insufficient slides for alignment
      // Add class if slides don't fill the viewport (less than slidesPerView) or if Swiper is locked
      if (thumbSlides.length < thumbConfig.slidesPerView || this.thumbSwiper.isLocked) {
        thumbSlider.classList.add('wlsn-buybox-gallery__thumb-slider--insufficient-slides');
      }
    }

    /**
     * Initialize the main slider
     * @returns {void}
     */
    initMainSlider() {
      const { mainSlider } = this.elements;
      if (!mainSlider) return;

      const mainConfig = {
        loop: true,
        spaceBetween: (10 / 10) * this.rem,
        keyboard: {
          enabled: true,
        },
        grabCursor: true,
      };

      mainConfig.thumbs = {
        swiper: this.thumbSwiper,
      };
      mainConfig.navigation = {
        nextEl: this.elements.mainNavButtonNext,
        prevEl: this.elements.mainNavButtonPrev,
      };

      this.mainSwiper = new Swiper(mainSlider, mainConfig);
    }

    /**
     * Hide the thumbnail slider
     * @returns {void}
     */
    hideThumbSlider() {
      const { thumbContainer } = this.elements;
      if (thumbContainer) {
        thumbContainer.classList.add(this.classes.hidden);
      }
    }
  }
  customElements.define('wlsn-buybox-gallery', WLSNBuyboxGallery);
}
